module.exports = __webpack_public_path__ + "img/brushes-1_en.fdf98a5.jpg";